import React ,{ useEffect, useRef, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { connect } from 'react-redux'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { setLeftPage } from '../../../actions/ui'
import { setOpenLogin, setLeftBoothList, setBookmardUpdated, setOpenBoothList } from '../../../actions/ui'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import Exhibitors from "./Exhibitors"
import { setActive3dObject, setLoading, setExhibitorList } from '../../../actions/main';
import { setSearchOptions } from '../../../actions/searchbox'
import SearchBox from '../SearchBox.js';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import axiosInstance from '../../../utils/axiosInstance.js'
import {
  useLocation
} from "react-router-dom";
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { getTokenCookie, getTokenPlanner, getUrlToken } from '../../../utils/Common'
import { ESHOW_URL } from '../../../config.js'
import Fade from '@mui/material/Fade';


function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

/**
 * Admin toolbar "Search booth" opens the same All Exhibitors list as View → All Exhibitors, but the SearchBox
 * should only offer exhibitor name and booth number filters. Every other entry to All Exhibitors keeps the
 * full STANDARD list from the API (Description, States, Countries, etc.).
 *
 * @param {object} apiResult - raw getExhibitorList response (expects SUCCESS + optional SEARCH)
 * @param {boolean} toolbarNarrowMode - true when opened via toolbar search button
 * @returns {object|undefined} payload for setSearchOptions (same shape as result.SEARCH)
 */
function narrowSearchOptionsForToolbar(apiResult, toolbarNarrowMode) {
  const search = apiResult.SEARCH;
  if (!toolbarNarrowMode || !search || !Array.isArray(search.STANDARD)) {
    return search;
  }
  const allowedIds = new Set(['exhibitor_name', 'booth_number']);
  const filtered = search.STANDARD.filter((opt) => opt && allowedIds.has(opt.ID));
  // If API IDs change, avoid returning an empty filter and breaking search silently.
  if (filtered.length === 0) {
    return search;
  }
  return {
    ...search,
    STANDARD: filtered,
    ADVANCE: [],
  };
}

/**
 * Tracks planner TOKEN + URL query for the last successful getExhibitorList (network or hydrate).
 * Survives All.js unmount when the drawer closes so reopening can reuse Redux cache without a new request.
 * (Refs inside Index reset on unmount; module state does not.)
 */
let _allExhibitorsLastFetchContext = { plannerStable: null, queryKey: null };

function Index(props) {
  const [boothList, setBoothList] = useState([]);
  const [loadingFlag, setLoadingFlag] = React.useState(false)
  const [loaded, setLoaded] = React.useState(false)
  let query = useQuery();

  /** Push API result into Redux + left booth list + local loaded state (shared by network and cache paths). */
  const applyExhibitorListResult = (result) => {
    if (!result.SUCCESS) {
      return;
    }
    const searchForStore = narrowSearchOptionsForToolbar(result, props.ui.commonSearchExhibitorBoothOnly);
    props.setSearchOptions(searchForStore);
    props.setExhibitorList(result);
    if (result.EXHIBITORS) {
      var boothListLocal = [];
      for (var i = 0; i < result.EXHIBITORS.length; i++) {
        var item = result.EXHIBITORS[i];
        if (!item?.SETUP?.LIST_PENDING_EXHIBITORS && item.STATUS == 2) {
          continue;
        }
        boothListLocal.push({
          booth: item['BOOTHS'] ? item['BOOTHS'] : '',
          BOOTHS: item['BOOTHS'] ? item['BOOTHS'] : '',
          name: item['BOOTHS'] ? item['BOOTHS'] : '',
          priced: false,
          id: '',
          EXHIBITOR_KEY: item['EXHIBITOR_KEY'] ? item['EXHIBITOR_KEY'] : '',
          company: item['COMPANY_NAME'] ? item['COMPANY_NAME'] : '',
          bookmark: item['BOOKMARKED'] ? item['BOOKMARKED'] : '',
          MAP_NAME: item['MAP_NAME'] ? item['MAP_NAME'] : '',
          MAP_KEY: item['MAP_KEY'] ? item['MAP_KEY'] : '',
          obj: item,
        });
      }
      boothListLocal.sort(function (a, b) {
        const nameA = (a.company + ' ' + a.name).toLowerCase();
        const nameB = (b.company + ' ' + a.name).toLowerCase();
        return `${nameA}`.localeCompare(`${nameB}`);
      });
      props.setLeftBoothList(boothListLocal);
    }
    setLoadingFlag(false);
    setLoaded(true);
  };

  const fetchExhibitorListFromNetwork = (plannerStable, queryKey) => {
    setLoadingFlag(true);
    setLoaded(false);
    var active_booth_file = props.main.active_booth_file;
    var token = getTokenCookie();
    var map_key;
    if (props.main.authInfo?.role != 'admin') {
      try {
        var _token = getTokenPlanner();
        if (_token) {
          token = _token;
        }
      } catch (e) {
        console.log('token parse', e);
      }
    }
    map_key = active_booth_file?.KEY_ID;
    if (query.get('map')) {
      map_key = query.get('map');
    }
    map_key = false;
    var url = `${ESHOW_URL()}?method=getExhibitorList&token=${token}${map_key ? '&map_key=' + map_key : ''}`;
    axiosInstance
      .get(url)
      .then((res) => {
        const result = res.data;
        if (result.SUCCESS) {
          applyExhibitorListResult(result);
          _allExhibitorsLastFetchContext = { plannerStable, queryKey };
        } else {
          setLoadingFlag(false);
        }
      })
      .catch(() => {
        setLoadingFlag(false);
      });
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var show_key = urlParams.get('show_key');
  var urlToken = getUrlToken();

  // Re-run when query / planner / toolbar narrow mode changes. Prefer Redux cache when the drawer was
  // closed and All unmounted — avoids getExhibitorList + loader on every reopen for the same map/planner.
  useEffect(() => {
    const plannerObj = props.main[`planner-${urlToken}`];
    // Use TOKEN string — the planner object identity changes when Redux updates; comparing refs would always refetch.
    const plannerStable =
      plannerObj && plannerObj.TOKEN != null ? String(plannerObj.TOKEN) : urlToken || '';
    const queryKey = query.toString();

    const cached = props.main.exhibitorList;
    const hasCache =
      cached && cached.SUCCESS && Array.isArray(cached.EXHIBITORS);

    const plannerChanged =
      _allExhibitorsLastFetchContext.plannerStable !== null &&
      _allExhibitorsLastFetchContext.plannerStable !== plannerStable;
    const queryChanged =
      _allExhibitorsLastFetchContext.queryKey !== null &&
      _allExhibitorsLastFetchContext.queryKey !== queryKey;

    if (hasCache && !plannerChanged && !queryChanged) {
      applyExhibitorListResult(cached);
      _allExhibitorsLastFetchContext = { plannerStable, queryKey };
      return;
    }

    fetchExhibitorListFromNetwork(plannerStable, queryKey);
  }, [query, props.main[`planner-${urlToken}`], props.ui.commonSearchExhibitorBoothOnly]);
  
  return (
    <Fade in={true} timeout={1200}>
      <div className='appLeftSearch'>
        {/* <Box display='flex' alignItems={'center'} justifyContent={'space-between'} sx={{width:'100%', padding:'10px 0 10px 10px', boxSizing:'border-box'}}>
          <Box sx={{width:'calc(100% - 40px)'}}>
            <SearchBox leftBar = {true}/>
          </Box>        
          <IconButton style={{marginRight:'4px'}} size="small" aria-label="close" color="inherit" onClick={()=>{props.setOpenBoothList(false)}}>
              <KeyboardDoubleArrowLeftOutlinedIcon />
          </IconButton>
        </Box> */}
        {/* <Box display="flex" style={{alignItems:'center', justifyContent:'space-between'}} pt={2}  pb={2}>
          
          <div style={{marginLeft:20}}></div>          
          <Box  style={{width:'100%'}}>
            <SearchBox/>
          </Box>
          <div style={{display:'flex', alignItems:'center', paddingRight:3}}>
            {props.role == 'admin' ?          
            <IconButton
                size="small"
                edge="start"
                aria-label="assign"
                style={{float:'right'}}
                onClick={()=>{props.setOpenBoothList(false)}}
              >
                <HighlightOffOutlinedIcon/>
            </IconButton>:
            <IconButton
              size="small"
              edge="start"
              aria-label="assign"
              style={{float:'right'}}
              onClick={()=>{props.setLeftPage('home')}}
            >
              <ChevronLeftIcon/>
            </IconButton>
            }
          </div>
        </Box> */}
        <Divider/>
        {loaded &&
        // <Exhibitors boothList={boothList} setBoothList={setBoothList} role={props.role} open={loaded} title='All Exhibitors'/>
        <Exhibitors role={props.role} open={loaded} title='All Exhibitors'/>
        }
        <LoadingOverlay
            active={loadingFlag}
            styles={{
                // spinner: (base) => ({
                // ...base,
                // width: '50px',
                // '& svg circle': {
                //     stroke: '#1976d2'
                // }
                // }),
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                // background: 'rgb(229 229 229 / 92%)',
                background: 'transparent',
                position:'absolute',
                left:'50%',
                top:'200px',
                transform:'translateX(-50%)',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
        </LoadingOverlay> 
      </div>
    </Fade>
  );
}

const mapStateToProps = (state) => {
  return {
    main: state.main,
    ui: state.ui,
    booth_history: state.booth_history.present
  };
};

const mapDispatchProps = (dispatch) => {
  return { 
    setLeftPage: value=>dispatch(setLeftPage(value)) ,
    setOpenLogin: value=>dispatch(setOpenLogin(value)) ,
    setLeftBoothList:  data=>dispatch(setLeftBoothList(data)),
    setBookmardUpdated:   data=>dispatch(setBookmardUpdated(data)),
    setOpenBoothList: value=>dispatch(setOpenBoothList(value)) ,
    setActive3dObject: value=>dispatch(setActive3dObject(value)) ,
    setLoading:  data=>dispatch(setLoading(data)),    
    setExhibitorList:  data=>dispatch(setExhibitorList(data)),
    setSearchOptions:  data=>dispatch(setSearchOptions(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
